import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../features/dialog';
import { deleteReport } from '../../features/report';
import { enqueueErrorSnack, enqueueSuccessSnack } from '../../features/snackbar';


const DIALOG_ID = "deleteReport"
const DIALOG_WIDTH = "sm"

function DeleteReportDialog() {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const project = useSelector(state => state.project.single);
    const reportId = useSelector((state) => state.dialog[DIALOG_ID])
    const reports = useSelector(state => state.report.list);
    const report = reports.find(t => t.id === reportId);
    const reportLabel = Array.isArray(reportId) ? "selected" : (report ? report.title : "");
    const show = !!reportId;

    const handleSubmit = e => {
        e && e.preventDefault() && e.stopPropagation();
        setLoading(true);
        dispatch(deleteReport({
            project,
            id: reportId
        }))
        .then(r => {
            dispatch(closeDialog(DIALOG_ID));
            dispatch(enqueueSuccessSnack("Report deleted"))
        })
        .catch(e => {
            dispatch(enqueueErrorSnack("Error: " + e))    
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const onClose = () => {
        dispatch(closeDialog(DIALOG_ID));
    }

    return <Dialog
        open={!!show}
        onClose={onClose}
        fullWidth
        maxWidth={DIALOG_WIDTH}
        
    >
        <form onSubmit={handleSubmit}>
            <DialogTitle>
                Delete report
            </DialogTitle>
            <DialogContent dividers={false}>
                <Typography variant="subtitle1">Are you sure you want to delete the <b>{reportLabel}</b> report?</Typography>
            </DialogContent>
            <DialogActions>
                {loading && <LinearProgress />}
                {!loading && <Box sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Button sx={{marginRight: 2}} onClick={onClose} >Cancel</Button>
                    <Button variant="contained" color="error" type="submit">Delete</Button>
                </Box>}
            </DialogActions>
        </form>
    </Dialog>
}

export default DeleteReportDialog;